import {
  createSelector,
} from 'reselect';

export const getApplicatioNameSelector = createSelector(state => state && state.test && state.test.name, name => name);
export const getButtonSelectedSelector = createSelector(state => state && state.test && state.test.buttonSelected, buttonSelected => buttonSelected);